import { h } from 'preact'
import InputGroup from '../ui-components/InputGroup'
import IdeationAddColor from './IdeationAddColor'
import { IdeaStatus, colorOptions } from './Types'

interface Props {
  title: string,
  data: IdeaStatus | null,
  colors: Array<string>,
  onCallback: (newData: IdeaStatus) => void,
  cancelCallback: () => void,
  isLoading: boolean,
  showError: boolean,
  errorMessage?: string,
  saveCallback: () => void
}

const IdeationAddEdit = (props: Props) => {
  if (props.data === null) {
    return null
  }
  return (
    <div className={`ideation-modal-container ${props.isLoading ? 'ideation-loading' : ''}`}>
      <div className='ideation-modal-title'>
        <h3>{ props.title }</h3>
      </div>
      {
        props.showError ? (
          <div className='alert alert-danger'>
            {
              props.errorMessage || 'Something went wrong, please try it again later.'
            }
          </div>
        ) : null
      }
      <form onSubmit={(e) => { e.preventDefault(); props.saveCallback() }}>
        <InputGroup
          title={'Status Name'}
          type={'text'}
          required
          onChange={(e) => props.onCallback(Object.assign({}, props.data, { name: e.target.value }))}
          value={props.data?.name}
          qaClasses='qa-ideation-name'
        />
        <IdeationAddColor
          title='Background Color'
          colors={props.colors}
          selectedColor={props.data.backgroundColor ? props.data.backgroundColor : props.colors[0]}
          type='backgroundColor'
          onCallback={(newData) => props.onCallback(Object.assign({}, props.data, newData))}
          qaClasses='qa-ideation-backgroundColor'
        />
        <IdeationAddColor
          title='Text Color'
          colors={[]}
          selectedColor={props.data.textColor ? props.data.textColor : '#fff'}
          type='textColor'
          onCallback={(newData: {
            [key: colorOptions]: string
          }) => props.onCallback(Object.assign({}, props.data, newData))}
          qaClasses='qa-ideation-textColor'
        />
        <div className='ideation-update-modal-footer'>
          <button disabled={props.isLoading} className='btn btn-default' onClick={props.cancelCallback}>Cancel</button>
          <button disabled={props.isLoading} className={`btn btn-primary ${props.isLoading ? 'is--loading' : ''}`}>
            <div className='btn--loader' />
            <span className='btn__hide-when-loading'>
            Save
          </span>
          </button>
        </div>
      </form>
    </div>
  )
}

export default IdeationAddEdit
